module.exports = __webpack_public_path__ + "static/img/cloud_xpress_connect_img_1_cn.366c7d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_svg/cloud_xpress_connect_img_1_cn.png
// module id = eV7E
// module chunks = 0